import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import LoadingIndicator from 'components/LoadingIndicator';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import ListTitle from 'components/ListTitle';
import useSiteCopySelector from 'components/useSiteCopySelector';
import { useJsApiLoader } from '@react-google-maps/api';
import Config from 'utils/getEnvConfig';
import { ButtonBase } from '@material-ui/core';
import PaddedGrid from 'components/PaddedGrid';
import useGeolocation from 'react-hook-geolocation';
import {
  getUserSavedCurrentLocation,
  getSortedDataWithLocation,
} from 'utils/userLocationService';
import LocationCard from '../../components/Locations/LocationCard';

const { MAP_API_KEY } = Config.GOOGLE;
const useStyles = makeStyles({
  root: {
    marginTop: 60,
  },
  viewAllBtnWrapper: {
    display: 'flex',
    justifyContent: 'center',
  },
  viewAllBtn: {
    padding: '0 10%',
    height: 46,
    background: 'white',
    border: '1px solid #0061A0',
    color: '#0061A0',
    fontSize: 15,
    fontFamily: 'PoppinsSemiBold',
  },
});

const LocationsByService = ({ data }) => {
  const classes = useStyles();
  const geolocation = useGeolocation();
  const dataWithLocation = data.filter(
    el => !_isEmpty(_get(el, 'fields.location', [])),
  );

  const [toggleValue, setToggleValue] = useState(4);
  const [resourceItemPageSiteCopy] = useSiteCopySelector([
    'resource-item-page',
  ]);
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: MAP_API_KEY,
  });
  const savedLocation = getUserSavedCurrentLocation(geolocation);
  if (_isEmpty(dataWithLocation)) return null;
  const sortedDataWithLocation = getSortedDataWithLocation(
    dataWithLocation,
    savedLocation,
  );
  const title = _get(
    resourceItemPageSiteCopy,
    'pageCopy.organizationLocationAndHoursHeader',
    '',
  );
  const dataLen = sortedDataWithLocation.length;
  return (
    <PaddedGrid container spacing={2} className={classes.root}>
      <PaddedGrid item xs={12}>
        <ListTitle title={title} />
      </PaddedGrid>
      {!isLoaded ? (
        <LoadingIndicator />
      ) : (
        <PaddedGrid item xs={12}>
          <Grid container direction="row" spacing={2}>
            {sortedDataWithLocation.slice(0, toggleValue).map(location => (
              <Grid
                item
                xs={12}
                sm={4}
                md={3}
                key={_get(location, 'fields.slug')}
              >
                <LocationCard data={location} />
              </Grid>
            ))}

            {dataLen > toggleValue && (
              <PaddedGrid item xs={12} className={classes.viewAllBtnWrapper}>
                <ButtonBase
                  className={classes.viewAllBtn}
                  onClick={() => setToggleValue(dataLen)}
                >
                  VIEW ALL LOCATIONS
                </ButtonBase>
              </PaddedGrid>
            )}
          </Grid>
        </PaddedGrid>
      )}
    </PaddedGrid>
  );
};

LocationsByService.propTypes = {
  data: PropTypes.array,
};

export default LocationsByService;
